<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.myOrder')" />
      <v-container class="white rounded-lg pa-5 pt-0">
        <v-row>
          <v-col :xl="4" :lg="6" :md="6" :cols="12" v-for="(menu, index) in menuList" :key="index">
            <div class="border-bottom d-flex flex-row justify-space-between align-center px-4 py-2">
              <div class="d-flex flex-row align-center">
                <v-img :src="menu.url" contain :min-width="25" :max-width="30" :height="35" class="white mr-3" />
                <h3 class="text-subtitle-1 secondary--text font-weight-bold">{{ menu.label }}</h3>
              </div>
              <router-link :to="{ name: $constants.ROUTE_NAME.ORDER_LIST, params: { id: menu.id } }" class="text-decoration-none">
                <v-icon color="green" class="white">mdi-chevron-right</v-icon>
              </router-link>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </LayoutContent>
  </div>
</template>

<script>
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import { localeHelper } from '@/utils'

export default {
  components: { LayoutContent, SectionTitle },
  name: 'Dashboard',
  data: () => ({
    menuList: [
      { id: 1, label: localeHelper.getMessage('label.toPay'), url: '/icons/order-to-pay.svg', redirectName: '' },
      { id: 2, label: localeHelper.getMessage('label.toShip'), url: '/icons/order-to-ship.svg', redirectName: '' },
      { id: 3, label: localeHelper.getMessage('label.toReceive'), url: '/icons/order-to-receive.svg', redirectName: '' },
      { id: 4, label: localeHelper.getMessage('label.delivered'), url: '/icons/order-delivered.svg', redirectName: '' },
      { id: 5, label: localeHelper.getMessage('label.completed'), url: '/icons/order-to-complete.svg', redirectName: '' },
      { id: 6, label: localeHelper.getMessage('label.cancelled'), url: '/icons/order-cancelled.svg', redirectName: '' },
      { id: 7, label: localeHelper.getMessage('label.returnRefund'), url: '/icons/order-return-refund.svg', redirectName: '' }
    ]
  })
}
</script>

<style lang="scss">
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.w-40 {
  width: 40%;
}

.border-none {
  text-decoration: transparent;
}

.custom-icon {
  width: 40px;
  height: 40px;
  margin: auto;
  margin-right: 10px;
  object-fit: contain;
  background-color: turquoise;
}
</style>
